module.exports = __webpack_public_path__ + "img/webhosting.c322da90.png";